import { defineStore } from 'pinia';
import { Snapshots, SnapshotsApiClient } from '@/repositories';

interface IAppState {
  waitHandle: number;
  priceMode: string;
  snapshots: Snapshots;
}

export const useStore = defineStore('main', {
  state: () =>
    ({
      waitHandle: 0,
      priceMode: 'financial',
      snapshots: {}
    }) as IAppState,
  getters: {
    snapshot: (state) => state.snapshots.current,
    previousSnapshot: (state) => state.snapshots.previous,
    currentPrices: (state) => (state.priceMode == 'financial' ? state.snapshots.current?.financial : state.snapshots.current?.physical),
    previousPrices: (state) => (state.priceMode == 'financial' ? state.snapshots.previous?.financial : state.snapshots.previous?.physical),
    intervention: (state) => state.snapshots.current?.intervention,
    suspension: (state) => state.snapshots.current?.suspension,
    administered: (state) => state.snapshots.current?.administered,
    isWaiting: (state) => state.waitHandle !== 0
  },
  actions: {
    setWaiting(waitHandle: number) {
      if (this.waitHandle !== waitHandle) {
        clearTimeout(this.waitHandle);
      }

      this.waitHandle = waitHandle;
    },
    loadSnapshots(interval: string | undefined, isRealTime: boolean): Promise<void> {
      let pollInterval = isRealTime ? 10000 : 0;
      const startPolling = async (resolve: () => void) => {
        let snapshots: null | Snapshots = null;
        try {
          snapshots = await new SnapshotsApiClient().get(isRealTime ? undefined : interval);
        } catch (e) {
          console.log('Caught exception, will retry.', e);
          pollInterval = 30000;
        }

        if (snapshots) {
          this.snapshots = snapshots;
          // Reset price mode if intervention no longer invoked in current interval
          this.setWaiting(0);
          resolve();
        }

        if (pollInterval > 0) {
          const handle = window.setTimeout(() => startPolling(resolve), pollInterval);
          this.setWaiting(handle);
        }
      };

      return new Promise(startPolling);
    }
  }
});
